import FileIcon from "components/shared/FileIcon";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowDownToBracket,
  faEye,
} from "@fortawesome/pro-regular-svg-icons";
import React from "react";
import classNames from "classnames";
import { includes } from "lodash";
import humanizeFileSize from "helpers/files/humanizeFileSize";
import formatDate from "helpers/formatDate";

type FileRowArgs = {
  extension: string;
  id: string;
  original_filename: string;
  created_at: string;
  size: number;
  content_type: string;
  chatId: string;
  author_name?: string;
  className?: string;
  showAuthor?: boolean;
};
export default function FileRow({
  extension,
  id,
  original_filename,
  size,
  content_type,
  author_name,
  chatId,
  className,
  showAuthor = false,
  created_at,
}: FileRowArgs) {
  const isOpenable =
    includes(["application/pdf", "text/html"], content_type) ||
    content_type?.indexOf("image/") === 0 ||
    content_type?.indexOf("text/") === 0;

  return (
    <div
      className={classNames(
        "grid grid-cols-[auto,1fr,auto] items-center gap-1 px-2 py-1 group/item",
        className,
      )}
    >
      <FileIcon extension={extension} />
      <div className="flex flex-col grow truncate">
        <a
          href={`/chat/${chatId}/files/${id}`}
          title={original_filename}
          className="grow truncate"
        >
          {original_filename}
        </a>
        <span className="text-xs text-muted">
          {showAuthor && <span>{author_name}</span>}
          {" • "}
          {humanizeFileSize(size)}
          {" • "}
          {created_at && formatDate(new Date(created_at), "dd.MM.y HH:mm")}
        </span>
      </div>
      <span className="file-actions flex gap-2 shrink-0 invisible group-hover/item:visible">
        {isOpenable && (
          <a
            className="muted decoration-0"
            href={`/api/storage/files/${id}/get/${original_filename}`}
            target="_blank"
            rel="noreferrer"
          >
            <FontAwesomeIcon className="fa-fw" icon={faEye} />
          </a>
        )}
        <a
          className="muted decoration-0"
          href={`/api/storage/files/${id}/get/${original_filename}?download`}
          target="_blank"
          rel="noreferrer"
        >
          <FontAwesomeIcon className="fa-fw" icon={faArrowDownToBracket} />
        </a>
      </span>
    </div>
  );
}
